var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 12.2857,
    fill: "url(#paint0_linear_387_5948)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2679 12.2857H14.4709C11.5677 12.2857 9.21436 14.6392 9.21436 17.5422V24.9393C9.21436 27.8424 11.5678 30.1958 14.4709 30.1958H29.2679C32.1711 30.1958 34.5245 27.8423 34.5245 24.9393V17.5422C34.5245 14.6392 32.171 12.2857 29.2679 12.2857ZM25.7129 21.6006L18.792 24.9015C18.6074 24.9895 18.3943 24.8552 18.3943 24.6509V17.8427C18.3943 17.6354 18.6131 17.5011 18.7977 17.5948L25.7187 21.102C25.9248 21.2063 25.9211 21.5015 25.7129 21.6006Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_387_5948",
    x1: 21.5,
    y1: 0,
    x2: 21.5,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F32313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A01F15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8814d46a10a896891b79f2165816582a.svg";
export { ForwardRef as ReactComponent };